import { render, staticRenderFns } from "./HandleData.vue?vue&type=template&id=4c28ba66&scoped=true&"
import script from "./HandleData.vue?vue&type=script&lang=js&"
export * from "./HandleData.vue?vue&type=script&lang=js&"
import style0 from "./HandleData.vue?vue&type=style&index=0&id=4c28ba66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c28ba66",
  null
  
)

export default component.exports